import { render, staticRenderFns } from "./LoadingList.vue?vue&type=template&id=70a59acd&scoped=true&"
import script from "./LoadingList.vue?vue&type=script&lang=js&"
export * from "./LoadingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a59acd",
  null
  
)

export default component.exports